import "./Modal.css";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import baseUrl from "../../url/baseUrl";
import { loginActions } from "../../store/userLogin-slice";
import { popupActions } from "../../store/popup-slice";

// Modal hiển thị khi thêm sp vào cart mà chưa đăng nhập
const Modal = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState("");
  const dispatch = useDispatch();

  // validate form
  const validateForm = () => {
    if (email.length < 3 && !email.includes("@")) {
      setError("Vui lòng nhập đúng email!");
      return false;
    }
    if (password.length < 8) {
      setError("Mật khẩu phải tối thiểu có 8 ký tự!");
      return false;
    }

    return true;
  };
  // handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }
    const url = baseUrl + "/login";
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
        mode: "cors",

        body: JSON.stringify({
          email: e.target.elements.email.value,
          password: e.target.elements.password.value,
        }),
      });

      if (response.status === 401) {
        throw new Error("Thông tin đăng nhập chưa đúng!");
      }

      if (response.status === 403) {
        throw new Error(
          "Tài khoản của bạn bị khóa, vui lòng liên hệ Admin để xử lý!"
        );
      }

      if (response.status !== 200) {
        throw new Error("Could not authenticate you!");
      }
      setError(null);
      const data = await response.json();
      console.log(data);
      // save information to localstorage
      localStorage.setItem("token", data.token);
      localStorage.setItem(
        "currentUser",
        JSON.stringify({
          isLogin: true,
          userId: data.userId,
          username: data.username,
          email: data.email,
          phone: data.phone,
          address: data.address,
        })
      );

      // update state in store
      dispatch(
        loginActions.ON_LOGIN(JSON.parse(localStorage.getItem("currentUser")))
      );
      // setup auto logout after token expired
      const remainingMilliseconds = 60 * 60 * 1000;
      // expired time calculated from starting login
      const expiryDate = new Date(new Date().getTime() + remainingMilliseconds);
      // save expired time to localstorage
      localStorage.setItem("expiryDate", expiryDate.toISOString());
      // logout when token expires (1 hour)
      setTimeout(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("expiryDate");
        localStorage.setItem("currentUser", JSON.stringify({ isLogin: false }));
        dispatch(loginActions.ON_LOGOUT(localStorage.getItem("currentUser")));
      }, remainingMilliseconds);

      dispatch(popupActions.hide_popup());
      // navigate("/");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="modal-overlay">
      <div style={{ width: "700px" }} className="modal-content rounded">
        <div className="d-flex justify-content-center">
          <form onSubmit={handleSubmit}>
            <h5 className="text-primary text-uppercase mb-4">
              Đăng nhập để tạo giỏ hàng
            </h5>
            <p className="text-danger text-center">{error}</p>
            <div className="mb-3">
              <div>
                <input
                  className="form-control mb-4"
                  id="email"
                  value={email}
                  type="email"
                  placeholder="Email"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div>
                <input
                  className=" form-control"
                  id="password"
                  value={password}
                  type="password"
                  placeholder="Password"
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>
            <div>
              <button className="btn btn-primary me-3" type="submit">
                Login
              </button>
              <button
                onClick={() => dispatch(popupActions.hide_popup())}
                className="btn btn-secondary"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>

        <p className="mt-5">
          Khách hàng mới?{" "}
          <Link to="/register" target="_blank">
            Đăng ký
          </Link>
        </p>
        <p>
          Quên mật khẩu?{" "}
          <Link to="/forgot-password" target="_blank">
            Cấp lại
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Modal;
